import V from 'gcl';
import Q from 'querystring';
/**
 * EMBServiceFactory
 * 自动调用远程EMB URL
 * EMB调用第三方的
 * 第三方调用第三方的
 * 第三方调用EMB不在此列
 */
export const EMBServiceFactory = class extends V.NiDataFactory {
    constructor(middler) {
        super();
        const that = this;
        that.regex = new RegExp('^((http|https):\\/\\/[\\w\\-_]+(\.[\\w\\-_]+)+([\\w\\-\\.,@?^=%&amp;:/~\\+#]*[\\w\\-\\@?^=%&amp;/~\+#])?)$', 'i');
        pri(that, {
            UrlConnection: class extends V.NiDataConnection {
                constructor() {
                    super();
                    const thats = this;
                    const {
                        _,
                        __
                    } = pri(this, {
                        cmds: [],
                        timeout: 60000,
                        system: {},
                        token: {},
                        template: 'emb-redis',
                        templatemanager: new V.NiTemplateManager(middler),
                        //通过orgID是否等于systemID实现调用第三方还是调用EMB
                        createToken: async function(orgID = __.systemID) {
                            const encID = __.encID;
                            try {
                                let sys = null;
                                //本地缓存5分钟
                                if (!__.system[orgID] || (__.system[orgID] && __.system[orgID].refreshTime > +new Date)) {
                                    //console.log(__.template, __.commandList.getSystemSql, { ID: orgID, encID });
                                    //过期
                                    let res = await __.templatemanager.execute(__.template, __.commandList.getSystemSql, { ID: orgID, encID });
                                    if (res.hasData()) {
                                        sys = V.json(res.single().value);
                                        if (3 != sys.DelFlag) throw new Error(`${orgID}系统目前不可用，请联系管理员!`);

                                        if (__.system[orgID] && (__.system[orgID].Key || '').eq(sys.Key) && (__.system[orgID].IV || '').eq(sys.IV)) {
                                            sys = __.system[orgID];
                                        } else {
                                            __.system[orgID] = sys;
                                            sys.crypt = new V.des3xcrypt(sys.Key, sys.IV);
                                        }
                                        sys.refreshTime = new Date().add('s', 300).getTime();
                                    } else throw new Error(`createToken 没有找到此注册系统信息:${orgID}，请联系管理员`);
                                } else sys = __.system[orgID]

                                //获取加密串
                                const crypt = sys.crypt;

                                //获取sessionID
                                let sessionID = null;
                                //本地缓存5分钟
                                if (!__.token[orgID] || (__.token[orgID] && __.token[orgID].refreshTime > +new Date)) {
                                    //过期
                                    let res = await __.templatemanager.execute("MT", __.commandList.getSystemTokenSql, {
                                        ID: orgID,
                                        encID
                                    });
                                    if (res.hasData()) {
                                        var token = (res.single()).split(',');
                                        sessionID = token[0];
                                        //兼容旧的会话信息 同时解决5分钟内遇到缓存过期问题
                                        !token[1] && (token[1] == Math.max);
                                        __.token[orgID] = { data: sessionID, refreshTime: Math.min(token[1], new Date().add('s', 300).getTime()) };
                                    } else {
                                        //直接生成
                                        let ret = await V.Net.post(sys.Host + sys.TokenURL, {
                                            _sys: __.systemID,
                                            _code: crypt.encrypt(V.toJsonString({
                                                login: new Date().getTime(),
                                                _: V.random()
                                            }))
                                        }) || {};
                                        try {
                                            ret = V.json(ret);
                                            if (ret[0].token) {
                                                var token = V.json(crypt.decrypt(ret[0].token));
                                                sessionID = token.sessionID;
                                                __.token[orgID] = { data: token.sessionID, refreshTime: new Date().add('s', 300).getTime() };
                                                await __.templatemanager.execute("MT", __.commandList.insertSystemTokenSql, {
                                                    ID: orgID,
                                                    encID,
                                                    _value: token.sessionID + ',' + new Date().add('h', ret[0].expire).getTime()
                                                });
                                            } else throw new Error(sys.Host + sys.TokenURL + ':' + V.toJsonString(ret));
                                        } catch (e) {
                                            console.log(e.message);
                                            throw new Error('createToken 没有获取到返回值:' + e.message);
                                        }
                                    }
                                } else sessionID = __.token[orgID].data;
                                return crypt.encrypt(V.toJsonString({
                                    sessionID,
                                    login: new Date().getTime(),
                                    _: V.random()
                                }));
                            } catch (e) {
                                throw new Error('createToken Token获取错误:' + e.message);
                            }
                        },
                        invoke: async(command, params) => {
                            const {
                                _,
                                __
                            } = pri(thats);
                            let args = (params.args ? params.args.value : params);
                            for (let i in args) {
                                if (args[i].value) args[i] = args[i].value;
                            }
                            const encID = __.encID;
                            let data = [];
                            await V.each(command.split(';'), async v => {
                                var orgID = args['_MonitorID'] || v.split('.')[0];
                                delete args['_MonitorID'];
                                if (!orgID) throw new Error(`请填写正确的命令名或者传入事件被监听的系统ID参数_MonitorID!`);
                                //这里不处理调用EMB web的情况 废除调用EMB使用自己的SystemID，调用第三方站点调用都使用对方的SystemID和Key
                                //(!orgID && __.systemID) && (args['_sys'] = orgID = __.systemID);

                                args['_token'] = await __.createToken(orgID);

                                if (!that.regex.test(v)) {
                                    //格式为命令名 需要替换URL
                                    let ret = await __.templatemanager.execute(__.template, __.commandList.getMethodSql, {
                                        encID,
                                        MethodName: v + '.Service'
                                    });
                                    if (ret && ret.hasData()) {
                                        var v2 = V.json(ret.single().value);
                                        v = v2.Url;
                                    } else {
                                        let sys = null;
                                        //通过是否传输_MonitorID区分EventName，MethodName
                                        //本地缓存5分钟
                                        if (!__.system[orgID] || (__.system[orgID] && __.system[orgID].refreshTime > +new Date)) {
                                            //过期
                                            let res = await __.templatemanager.execute(__.template, __.commandList.getSystemSql, { ID: orgID, encID });
                                            if (res.hasData()) {
                                                sys = V.json(res.single().value);
                                                if (3 != sys.DelFlag) throw new Error(`${orgID}系统目前不可用，请联系管理员!`);

                                                if (__.system[orgID] && (__.system[orgID].Key || '').eq(sys.Key) && (__.system[orgID].IV || '').eq(sys.IV)) {
                                                    sys = __.system[orgID];
                                                } else {
                                                    __.system[orgID] = sys;
                                                    sys.crypt = new V.des3xcrypt(sys.Key, sys.IV);
                                                }
                                                sys.refreshTime = new Date().add('s', 300).getTime();
                                            } else throw new Error('createToken 没有找到此注册系统信息，请联系管理员');
                                        } else sys = __.system[orgID]
                                        if (sys) {
                                            v = `${sys.Host}/_/${v.split('.').slice(1).join('/')}${sys.AutoCommand}`;
                                        } else
                                            throw new Error(`系统信息未找到${orgID}`);
                                    }
                                }

                                //URL
                                const text = (await V.Net.post(v, args)) || '';
                                try {
                                    data.push(V.json(text)[0]);
                                } catch (e) {
                                    data.push(text);
                                }
                                return false;
                            }, true);
                            return data;
                        }
                    });
                }
                async open() {
                    const {
                        _,
                        __
                    } = pri(this);
                    __.systemID = _.params.SystemID; //通过systemID是否设定值实现调用第三方还是调用EMB
                    __.encID = _.params.encID;
                    __.template = _.params.template || __.template; //默认的模板配置
                    //请务必实现emb-redis连接
                    __.commandList = V.merge({
                        getSystemSql: 'emb-api.redis.getSystem',
                        getSystemTokenSql: 'emb-api.redis.getSystemToken',
                        insertSystemTokenSql: 'emb-api.redis.insertSystemToken',
                        getMethodSql: "emb-api.redis.getMethod",
                    }, _.params.commandList || {});
                    __.expire = _.params.expireTime || 8;
                    await super.open();
                }
                async close() {
                    await super.close();
                }
                async invoke(cmd) {
                    const {
                        _,
                        __
                    } = pri(this);
                    if (_.transaction) {
                        __.cmds.push({
                            command: cmd.command,
                            params: cmd.params
                        });
                    } else
                        return await __.invoke(cmd.command, cmd.params);
                }
                async commit() {
                    const {
                        _,
                        __
                    } = pri(this);
                    if (_.transaction) {
                        //事务性处理
                        let data = [];
                        let cmds = __.cmds;
                        __.cmds = [];
                        await V.each(cmds, async v => {
                            data.push(await __.invoke(v.command, v.params));
                            return false;
                        }, true);
                        return data;
                    } else
                        throw new Error('非事务条件下不可调用此方法');
                }
            }
        });
    }
    createDBConnection() {
        const {
            _,
            __
        } = pri(this);
        return new __.UrlConnection();
    }
};

export default {
    EMBServiceFactory
};
const pri = V.pris();